export default "/images/icon-bullet.svg?9862e04e4e9642466191a8eb821f76cd";